import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

@Component({
    selector: 'don-payment-element-view',
    imports: [CommonModule],
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentElementViewComponent implements AfterViewInit, OnDestroy {
  /** ID único del contenedor donde se montará Stripe Elements */
  @Input({ required: true }) containerId!: string;

  /** Señal desde el store: true cuando el Element ya está montado */
  @Input() isReady = false;

  /** Señal desde el store: true mientras se confirma el pago */
  @Input() isConfirming = false;

  /** Habilita/deshabilita el botón (además de isReady/isConfirming) */
  @Input() active = true;

  /** Texto del botón de confirmación */
  @Input() confirmLabel = 'Donate';

  /** Mostrar u ocultar el skeleton mientras no esté listo */
  @Input() showSkeleton = true;

  /** Mostrar botón secundario de regreso debajo del Payment Element */
  @Input() showBackButton = false;

  /** Texto del botón de regreso */
  @Input() backLabel = 'Back';

  /** Emite al finalizar el AfterViewInit (para que el effect monte Stripe) */
  @Output() viewEntered = new EventEmitter<string>();

  /** Emite al destruir el componente (para desmontar Stripe) */
  @Output() viewExited = new EventEmitter<void>();

  /** Emite cuando el usuario hace click en confirmar */
  @Output() confirmClicked = new EventEmitter<void>();

  /** Emite cuando el usuario hace click en regresar */
  @Output() backClicked = new EventEmitter<void>();

  constructor() {}

  ngAfterViewInit(): void {
    // Avisamos al efecto que la vista está lista y puede montar con #containerId
    this.viewEntered.emit(this.containerId);

  }

  ngOnDestroy(): void {
    // Avisamos al efecto que puede desmontar el Element
    this.viewExited.emit();
  }

  onConfirmClick(): void {
    this.confirmClicked.emit();
  }

  onBackClick(): void {
    this.backClicked.emit();
  }
}
